module.exports = __webpack_public_path__ + "img/fiji.902a5149.svg";